import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { PasswordChangeModals } from '@/features/user/components/password-change-modals';

import { Header } from '../ui/header/header';
import { SignOutModal } from '../ui/modal/sign-out-modal';
import { NavigationMenu } from '../ui/sidebar/navigation-menu';

type NavigationLayoutProps = {
  children: React.ReactNode;
};

export const NavigationLayout = (props: NavigationLayoutProps) => {
  console.info('navigation-layout.tsx_1');

  const {
    isOpen: isSignOutModalOpen,
    onOpen: onSignOutModalOpen,
    onClose: onSignOutModalClose,
  } = useDisclosure();
  const {
    isOpen: isPasswordChangeFormModalOpen,
    onOpen: onPasswordChangeFormModalOpen,
    onClose: onPasswordChangeFormModalClose,
  } = useDisclosure();
  const { children } = props;

  return (
    <>
      <Box h={{ base: '60px' }}>
        <Header
          onPasswordChangeFormModalOpen={onPasswordChangeFormModalOpen}
          onSignOutModalOpen={onSignOutModalOpen}
        />
      </Box>
      <Box w="100vw" h={{ base: 'calc(100vh - 61px)' }}>
        <Flex w="100%" minH="100%">
          <NavigationMenu />
          <Box w={{ base: '90vw' }} bg="white" border="black">
            <Box h="100%" shadow={{ base: 'md' }} p={{ base: 2, lg: 4 }}>
              {children}
            </Box>
          </Box>
        </Flex>
      </Box>
      <SignOutModal isOpen={isSignOutModalOpen} onClose={onSignOutModalClose} />
      <PasswordChangeModals
        isPasswordChangeFormModalOpen={isPasswordChangeFormModalOpen}
        onPasswordChangeFormModalClose={onPasswordChangeFormModalClose}
      />
    </>
  );
};
